
<template>
<div class="">
    <list-template ref="list-template" :hasSearch="false" actionUrl="question/selectUserQuestion.action" :queryParams="searchInfo">
        <template slot="item" scope="scope">
            <el-table
              :data="datas"
              border
              v-loading.body="loading"
              style="width: 100%">
              <el-table-column
                label="ID"
                width="70">
                <template scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.id }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="渠道名"
                width="250">
                <template scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.channelName }} {{scope.row.channelPageName?'('+scope.row.channelPageName+')':''}}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="对接人"
                width="100"
                >
                <template scope="scope">
                  <span>{{scope.row.abutmentPersonName}}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="发布时间"
                width="180">
                <template scope="scope">
                  <span>{{scope.row.createTime | dateTimeFormat}}</span>
                </template>
              </el-table-column>
            </el-table>

        </template>
    </list-template>
</div>
</template>

<script>

import questionModel from '../../../framework/models/questionModel'
import BasicPager from '../../../mixins/BasicPager'
import ListTemplate from '../../../components/ListTemplate'
export default {
  name: 'question-user-detail',
  extends: BasicPager,
  data: function () {
    return {
      searchInfo: {
        userId: null
      },
      datas: []
    }
  },
  components: {
    ListTemplate
  },
  created: function () {
    this.searchInfo.userId = this.$route.params.userId
    this.selectUserQuestion()
  },
  methods: {
    selectUserQuestion: function () {
      let _this = this
      let params = {
        userId: this.searchInfo.userId
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
        }
      }
      questionModel.selectUserQuestion(_this, params, listener)
    }
  }
}

</script>
